
import { createReducer } from '@reduxjs/toolkit';
import {
    SET_PODCASTS_DATA, SET_IS_LOADING_NEWS, SET_PODCAST_EPISODES,
    SET_LOADING_TEXT, SET_CURRENT_PODCAST_SHOW,
} from '../actions/PodcastsAction';

const initialCurrentPodcastShow = false;

const currentPodcastShow = createReducer(initialCurrentPodcastShow, (builder) => {
    builder.addCase(SET_CURRENT_PODCAST_SHOW, (state, action) => action.data);
});

const initialState = {
    isLoadingNews: false, // @TODO change to isLoadingPodcasts?
    loadingText: '',
    proContentLoaded: false,
    podcastsData: [],
    podcastEpisodes: [],
};

const simplecastPodcasts = createReducer(initialState, (builder) => {
    builder
        .addCase(SET_IS_LOADING_NEWS, (state, action) => {
            state.isLoadingNews = action.isLoading;
        })
        .addCase(SET_PODCASTS_DATA, (state, action) => {
            state.proContentLoaded = action.data.proContentLoaded;
            state.podcastsData = action.data.podcastsData;
        })
        .addCase(SET_CURRENT_PODCAST_SHOW, (state) => {
            state.podcastEpisodes = [];
        })
        .addCase(SET_PODCAST_EPISODES, (state, action) => {
            state.podcastEpisodes = state.podcastEpisodes.concat(action.data);
        })
        .addCase(SET_LOADING_TEXT, (state, action) => {
            state.loadingText = action.loadingText;
        });
});

export { simplecastPodcasts, currentPodcastShow };
